import { useNavigate } from 'react-router-dom';
import { haptic } from '../lib/telegram';

/**
 * Універсальний заголовок сторінки.
 *
 * `backTo` — куди вести кнопку "назад" (наприклад "/battles"). Якщо передано,
 * ліворуч від заголовку з'явиться шеврон "‹". Якщо `onBack` — викликається
 * замість navigate (для кастомних дій типу "піти на крок назад у формі").
 */
export function PageHeader({
  title,
  subtitle,
  right,
  backTo,
  onBack,
}: {
  title: string;
  subtitle?: string;
  right?: React.ReactNode;
  backTo?: string;
  onBack?: () => void;
}) {
  const navigate = useNavigate();
  const showBack = !!backTo || !!onBack;

  const handleBack = () => {
    haptic.light();
    if (onBack) onBack();
    else if (backTo) navigate(backTo, { replace: true });
  };

  return (
    <header className="sticky top-0 z-10 border-b border-tg-secondary-bg bg-tg-bg/95 px-4 pt-[env(safe-area-inset-top)] backdrop-blur">
      <div className="flex items-center justify-between gap-2 py-3">
        <div className="flex min-w-0 items-center gap-2">
          {showBack && (
            <button
              onClick={handleBack}
              aria-label="Назад"
              className="grid h-8 w-8 shrink-0 place-items-center rounded-full text-xl text-tg-link transition active:bg-tg-secondary-bg"
            >
              ‹
            </button>
          )}
          <div className="min-w-0">
            <h1 className="truncate text-lg font-semibold leading-tight">{title}</h1>
            {subtitle && <p className="truncate text-xs text-tg-hint">{subtitle}</p>}
          </div>
        </div>
        {right}
      </div>
    </header>
  );
}
